import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  footerWrapper: {
    padding: "0 22px 15px 22px",
  },
  footerSection: {
    marginBottom: 28,
  },
  footerSectionTitle: {
    marginBottom: 28,
    fontSize: 18,
    lineHeight: "18px",
    fontWeight: "bold",
    color: "#465869",
  },
  footerIconButton: {
    marginRight: "10px !important",
  },
  footerLogoutButton: {
    background: "#FEE4E2",
    color: "#F97066",
    width: 144,
    height: 40,
    borderRadius: 8,
  },
  actionsButton: {
    fontWeight: 700,
    padding: "12.5px 20px",
  },
  anchorContainer: {
    marginTop: "52px",
    "& .MuiListItem-button:hover": {
      backgroundColor: "#EDF5FB",
      color: "#308CDB",
      fontWeight: 600,
    },
  },
  anchorButtonActive: {
    backgroundColor: "#03569E"
  },
  anchorItem: {
    color: "#667085",
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: "Manrope",
    minWidth: "148px",
    height: "40px"
  },
  ml8: {
    marginLeft: "8px"
  },
  paperProps: {
    transform: "translateY(-180px)",
  },
  menuListProps: {
    padding: 0
  }
}));

export default styles;
